module.exports = __webpack_public_path__ + "static/more-tales-of-the-unexpected-dd988e1b0877d7a9fd2c79d45c4b3839.jpg";